import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')

// Page names
export const PAYMENTS_LIST_PAGE_NAME = 'cabinet:payments'

// URLs
export const PAYMENTS_LIST_PAGE_URL = ''


export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(PAYMENTS_LIST_PAGE_URL, list, PAYMENTS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'payments',
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
